import { Route, Routes } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';

import FichePanne from './maintenance/FichePanne';
import ListePannes from './maintenance/ListePannes';

/**
 * L'écran « Maintenance » du registre, et son routage interne — le technicien
 * (Beaucour, 13/10).
 *
 * Même forme que `MesChambres` : le registre monte ce composant derrière
 * `/maintenance/*`. `/maintenance` est la liste en trois onglets ;
 * `/maintenance/:issueId` est la fiche d'une panne — c'est là que mènent les
 * pushes de signalement, d'affectation et de résolution (`mobile_path`).
 *
 * La clé remonte tout à neuf quand l'établissement change (#25).
 */
export default function Maintenance() {
    const { currentFacility } = useStateContext();
    const cleEtablissement = String(currentFacility?.id ?? 'aucun');

    return (
        <Routes>
            <Route index element={<ListePannes key={cleEtablissement} />} />
            <Route path=":issueId" element={<FichePanne key={cleEtablissement} />} />
        </Routes>
    );
}
